module.exports = __webpack_public_path__ + "static/media/StarFull.af3ffc35.svg";